/**
 * 缓存说明:
 */
import vm from '@/cache/storeTools.js'
import systemApi from '@/components/api/systemApi.js'
import resourcesStore from '@/cache/resourcesStore.js'
var basestate = {
	setBuilding:"", //新页面建筑选项
	setIsCollapse:false,//侧边栏收缩
	setDevice:"", //预测性维护选择的设备
	webConfig: undefined,
	nowWeLogo:true,
	//当前系统中选中的时间对象
	nowSelectDate: undefined,
	//当前选中的应用类型组id列表
	nowSelectAppTypeGroupIds: [],
	theme:'theme1',
	transformerList:[],
	eventToOrderCache:undefined,
	nowTimeInterval:{},
	meterTimeInterval: {},
	operateRecordsTimeInterval: {},
	billReportTimeInterval: {},
	financeReportTimeInterval: {},
	socketState:false,//socket连接状态
	weather:{
		cityInfo:{city:'--'},
		data:{forecast:[{type:'--',high:'高温 --℃',low:'低温--℃'}]}
		},//天气缓存
	selectCable:{},//选中的线缆数据
	load:false,//加载中,
	skinFlag:true
}
var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getWebConfig(state, getters) {
			if (state.webConfig == undefined) {
				store.commit("getWebConfig")
				return {}
			}
			return state.webConfig
		},
		getNowSelectDate(state) {
			if (state.nowSelectDate == undefined) {
				return new Date()
			}
			return state.nowSelectDate
		},
		getNowTimeInterval(state) {
			if (state.nowTimeInterval.startDate == undefined) {
				var date = new Date()
				var year = date.getFullYear()
				var month = date.getMonth()
				var day = date.getDate()
				var startDate = new Date(year, month, day)
				var endDate = new Date(startDate.getTime() + 24 * 60 * 60 - 1000)
				return {startDate:startDate, endDate:endDate}
			}
			return state.nowTimeInterval
		},
		getMeterTimeInterval(state) {
			if (state.meterTimeInterval.startDate == undefined) {
				var date = new Date()
				var startDate = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000))
				return {startDate:startDate, endDate:date}
			}
			return state.meterTimeInterval
		},
		getOperateRecordsTimeInterval(state) {
			if (state.meterTimeInterval.startDate == undefined) {
				var date = new Date()
				var startDate = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000))
				return {startDate:startDate, endDate:date}
			}
			return state.operateRecordsTimeInterval
		},
		getBillTimeInterval(state) {
			if (state.billReportTimeInterval.startDate == undefined) {
				var date = new Date()
				var startDate = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000))
				return {startDate:startDate, endDate:date}
			}
			return state.billReportTimeInterval
		},
		getfinanceTimeInterval(state) {
			if (state.financeReportTimeInterval.startDate == undefined) {
				var date = new Date()
				var startDate = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000))
				return {startDate:startDate, endDate:date}
			}
			return state.financeReportTimeInterval
		},
		
		getNowSelectAppTypeGroupIds(state) {
			//默认选中一个，如果有选中的则取交集
			return list => {
				if (isempty(list)) {
					return []
				}
				if (isempty(state.nowSelectAppTypeGroupIds)) {
					return [list[0].id]
				}
				var ids = list.map(item=>{
					return item.id
				})
				// console.log("state.nowSelectAppTypeGroupIds",state.nowSelectAppTypeGroupIds);
				var l = state.nowSelectAppTypeGroupIds.filter(item=>{
					return ids.includes(item)
				})
				if(l.length == 0){
					//如果不匹配，那就返回至少一个
					return [list[0].id]
				}
				return l
			}
		}
	},
	mutations: {
		//新页面建筑选项
		setBuilding(state,data){
			// console.log("收到的",data);
			vm.Vue.set(state, 'setBuilding', data)
		},
		//设置皮肤刷新
		setSkinFlag(state,data){
			vm.Vue.set(state, 'skinFlag', data)
		},
		//侧边栏收缩
		setIsCollapse(state,data){
			vm.Vue.set(state, 'setIsCollapse', data)
		},
			//预测性维护选中的设备
			setDevice(state,data){
				// console.log("收到的",data);
				vm.Vue.set(state, 'setDevice', data)
			},
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getWebConfig(state) {
			var styleName = localStorage.getItem("themeName")
			
			systemApi.getWebConfig(styleName,respon => {
				vm.Vue.set(state, 'webConfig', respon)
				resourcesStore.commit('setFilePath',respon.Style)
			})
		},
		getLogo(state,val){
			vm.Vue.set(state, 'nowWeLogo', val)
		},

		setNowSelectDate(state, date) {
			vm.Vue.set(state, 'nowSelectDate', date)
		},
		setNowTimeInterval(state, timeInterval){
			vm.Vue.set(state, 'nowTimeInterval', timeInterval)
		},
		setMeterTimeInterval(state, timeInterval){
			vm.Vue.set(state, 'meterTimeInterval', timeInterval)
		},
		setNowSelectAppTypeGroupIds(state,list){
			vm.Vue.set(state, 'nowSelectAppTypeGroupIds', list)
		},
		setTransformerList(state,data){
			vm.Vue.set(state,'transformerList',data)
		},
		setOperateRecordsTimeInterval(state, timeInterval){
			vm.Vue.set(state, 'operateRecordsTimeInterval', timeInterval)
		},
		setBillTimeInterval(state, timeInterval){
			vm.Vue.set(state, 'billReportTimeInterval', timeInterval)
		},
		setfinanceTimeInterval(state, timeInterval){
			vm.Vue.set(state, 'financeReportTimeInterval', timeInterval)
		},
	}
});
//对外提供
export default store
